export interface ITimings {
	questionReveal: number
	questionTransition: number
}

const timings: ITimings = {
	questionReveal: 3,
	questionTransition: 5,
}

export default timings
